export const Spacer: React.FC<{}> = () => <div className="flex-1" />;
